import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { SafeArea, Image, Button } from "antd-mobile"
import React, { FC } from "react"
import styles from "./index.module.less"
import { useNavigate } from "react-router-dom"
import { getSuiShenXingAuthCode } from "~src/service/suishenxing"


const Auth: FC = () => {
  useDocumentTitle('碳普惠平台申请')
  const navigate = useNavigate()
  const activityPath = process.env.REACT_APP_SUISHENXING
  const onAgreeAuth = async () => {
    const { code } = await getSuiShenXingAuthCode()
    window.location.href = `${activityPath}?authcode=${code}&clientId=lvmiao0000000001`
  }
  const onCancelAuth = () => {
    navigate(-1)
  }
  return <div className={styles.wrap}>
    <Image className={styles['wrap-header']} src="https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/activites/suishenxing/suishenxing_auth_icon.png" />
    <div className={styles['wrap-title']}>即将进入上海市碳普惠绿色出行平台</div>
    <div className={styles['wrap-subtitle']}>上海市碳普惠绿色出行平台申请获取您在绿喵的手机号，用于碳平台账户开通和登录。</div>
    <div className={styles['wrap-footer']}>
      <Button block shape='rounded' className={styles["wrap-primarybtn"]} element-id="同意授权" element-content="随申行-同意授权" onClick={onAgreeAuth}>
        同意授权
      </Button>
      <Button block shape='rounded' className={styles["wrap-cancelbtn"]} element-id="暂不授权" element-content="随申行-暂不授权" onClick={onCancelAuth}>
        暂不授权
      </Button>
    </div>
    <SafeArea position='bottom' />
  </div>
}
export default Auth
